<template>
  <form-builder-editor-field
    :item="item"
    :show-hide-in-form="true"
    :show-hide-in-preview="true"
    :show-hide-in-reports="true"
    :show-required="true"
    :show-share-with-participant="true"
    :show-is-shared="true"
    v-on="$listeners"
  >
    <editor-options-list
      :values="item.values"
      :id="item.name"
      :edit-value="true"
      :show-templates="true"
    />
  </form-builder-editor-field>
</template>

<script>
import FormBuilderEditorField from "./FormBuilderEditorField";
import EditorOptionsList from "./EditorOptionsList";

export default {
  components: {EditorOptionsList, FormBuilderEditorField},

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  setup() {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// FormBuilderEditorRadioGroup.vue?2b5281e6